import React from 'react';
import { Checkbox as UiCheckbox } from '@components/ui/checkbox';
import { cn } from '@core/utils/cn';

interface CheckboxProps {
    checked: boolean;
    children: React.ReactNode;
    required?: boolean;
    center?: boolean;
    disabled?: boolean;
    onChange?(
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean
    ): void;
}

export function Checkbox(props: CheckboxProps) {
    const id = React.useId();
    return (
        <label
            htmlFor={id}
            className={cn(
                'flex cursor-pointer gap-2 text-sm',
                props.center ? 'items-center' : 'items-start',
                props.disabled && 'cursor-not-allowed opacity-60'
            )}
        >
            <UiCheckbox
                id={id}
                checked={props.checked}
                required={props.required}
                disabled={props.disabled}
                className="mt-0.5"
                onCheckedChange={(checked) =>
                    props.onChange?.(
                        {
                            target: { checked: checked === true }
                        } as React.ChangeEvent<HTMLInputElement>,
                        checked === true
                    )
                }
            />
            <span>{props.children}</span>
        </label>
    );
}
